module.exports = __webpack_public_path__ + "static/media/435_Office.8073f6ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/435_Office.jpg
// module id = 565
// module chunks = 0